<template>
    <ValidationObserver v-slot="{ invalid, validate }">
        <form
            class="join-form row justify-content-center"
            @submit.prevent="validate().then(handleJoin)"
        >
            <div class="join-form__inputs-group col-md-8 col-lg-6 col-xl-4">
                <!-- <CustomSelect
                    class="mb-15px"
                    :label="$t('forms.labels.accountRole')"
                    :options="selectOptions"
                    :default="defaultSelectValue"
                    @input="currentAccountRole = $event.value"
                /> -->

                <!-- <template v-if="currentAccountRole === 'author'">
                    <ValidationProvider
                        v-for="input in joinFormInputsAuthor"
                        :key="joinFormInputsAuthor.validationProviderName"
                        v-slot="{ errors }"
                        :rules="input.validationProviderRules"
                        :name="input.validationProviderName"
                    >
                        <CustomInput
                            v-model="account[input.model]"
                            :type="input.type"
                            :label="$t(input.label)"
                            :errors="errors"
                            :showPasswordIcon="input.showPasswordIcon"
                            @showPassword="input.type = $event"
                        />
                    </ValidationProvider>
                </template> -->

                <!-- <p class="join-form__title">
                    {{ $t('forms.joinForm.accountInfo') }}
                </p> -->

                <ValidationProvider
                    v-for="input in joinFormInputsCommon"
                    :key="joinFormInputsCommon.validationProviderName"
                    v-slot="{ errors }"
                    :rules="input.validationProviderRules"
                    :vid="input.model === 'password' ? input.validationProviderVid : ''"
                    :name="input.validationProviderName"
                >
                    <CustomInput
                        v-model="account[input.model]"
                        :type="input.type"
                        :label="$t(input.label)"
                        :errors="errors"
                        :hint="$t(input.hint)"
                        :showPasswordIcon="input.showPasswordIcon"
                        @showPassword="input.type = $event"
                    />
                </ValidationProvider>

                <div>
                    <div class="join-form__notification">
                        <div class="d-flex note">
                            <div class="join-form__notification-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.75">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12.6459 16.7848C11.7109 16.7848 10.9544 16.5808 10.3764 16.1728C9.7984 15.7647 9.50939 15.1825 9.50939 14.426C9.50939 13.95 9.65814 13.5123 9.95564 13.1128C10.2616 12.7133 10.6441 12.4243 11.1031 12.2458C10.6611 12.0843 10.3041 11.8335 10.0321 11.4935C9.76014 11.145 9.62414 10.7285 9.62414 10.244C9.62414 9.5045 9.92164 8.94775 10.5166 8.57375C11.1116 8.19125 11.8214 8 12.6459 8C13.4704 8 14.1801 8.19125 14.7751 8.57375C15.3701 8.94775 15.6676 9.5045 15.6676 10.244C15.6676 10.7285 15.5274 11.145 15.2469 11.4935C14.9749 11.8335 14.6179 12.0843 14.1759 12.2458C14.6349 12.4243 15.0174 12.7133 15.3234 13.1128C15.6294 13.5037 15.7824 13.9373 15.7824 14.4132C15.7824 15.1698 15.4891 15.7563 14.9026 16.1728C14.3246 16.5808 13.5724 16.7848 12.6459 16.7848ZM12.6459 11.519C12.8669 11.468 13.0794 11.366 13.2834 11.213C13.4959 11.0515 13.6021 10.8475 13.6021 10.601C13.6021 10.3375 13.5171 10.1335 13.3471 9.989C13.1771 9.836 12.9434 9.7595 12.6459 9.7595C12.3484 9.7595 12.1146 9.836 11.9446 9.989C11.7746 10.1335 11.6896 10.3375 11.6896 10.601C11.6896 10.8475 11.7916 11.0515 11.9956 11.213C12.2081 11.366 12.4249 11.468 12.6459 11.519ZM12.6459 15.0253C12.9519 15.0253 13.2069 14.9488 13.4109 14.7958C13.6149 14.6343 13.7169 14.4175 13.7169 14.1455C13.7169 13.8565 13.5936 13.6185 13.3471 13.4315C13.1091 13.236 12.8754 13.1213 12.6459 13.0872C12.4164 13.1213 12.1784 13.236 11.9319 13.4315C11.6939 13.6185 11.5749 13.8565 11.5749 14.1455C11.5749 14.4175 11.6726 14.6343 11.8681 14.7958C12.0721 14.9488 12.3314 15.0253 12.6459 15.0253ZM8.5135 16.6318H6.448V10.7668L5.173 12.0673L4 10.8433L6.7285 8.1275H8.5135V16.6318ZM19.5563 12.8833H21.4178V11.774H19.5563V9.7085H18.3323V11.774H16.4708V12.8833H18.3323V15.0508H19.5563V12.8833Z" fill="white"/>
                                    </g>
                                </svg>
                            </div>

                            <p class="join-form__notification-paragraph">
                                {{ $t('forms.notes.ageAcceptNote') }}
                            </p>
                        </div>

                        <div class="d-flex note mb-30px">
                            <div class="join-form__notification-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.75">
                                        <path d="M5.625 1.5C4.589 1.5 3.75 2.34 3.75 3.375V20.625C3.75 21.66 4.59 22.5 5.625 22.5H18.375C19.41 22.5 20.25 21.66 20.25 20.625V12.75C20.25 11.7554 19.8549 10.8016 19.1517 10.0983C18.4484 9.39509 17.4946 9 16.5 9H14.625C14.1277 9 13.6508 8.80246 13.2992 8.45083C12.9475 8.0992 12.75 7.62228 12.75 7.125V5.25C12.75 4.25544 12.3549 3.30161 11.6517 2.59835C10.9484 1.89509 9.99456 1.5 9 1.5H5.625Z" fill="white"/>
                                        <path d="M12.9707 1.81592C13.7972 2.76888 14.2515 3.98846 14.2497 5.24992V7.12492C14.2497 7.33192 14.4177 7.49992 14.6247 7.49992H16.4997C17.7612 7.49817 18.9807 7.9524 19.9337 8.77892C19.4937 7.10563 18.6172 5.57922 17.3938 4.3558C16.1704 3.13239 14.644 2.25588 12.9707 1.81592Z" fill="white"/>
                                    </g>
                                </svg>
                            </div>

                            <i18n
                                path="forms.notes.policyAcceptNote"
                                tag="p"
                                class="join-form__notification-paragraph"
                            >
                                <template v-slot:termsAndConditions>
                                    <nuxt-link :to="localePath('/terms-and-conditions')">{{ $t('pages.termsAndConditions.title') }}</nuxt-link>
                                </template>
                                <template v-slot:privacyPolicy>
                                    <nuxt-link :to="localePath('/privacy-policy')">{{ $t('forms.subscribeForm.privacyPolicyShort') }}</nuxt-link>
                                </template>
                            </i18n>
                        </div>

                        <!-- Temporary hidden below -->
                        <!-- <div class="join-form__checkbox-container">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.503 6.97725C1.54107 6.10852 1.91297 5.288 2.54119 4.68676C3.1694 4.08551 4.00543 3.74994 4.875 3.75H19.125C19.9946 3.74994 20.8306 4.08551 21.4588 4.68676C22.087 5.288 22.4589 6.10852 22.497 6.97725L21.39 7.59225L12 12.648L2.61 7.59225L1.503 6.97725ZM1.5 8.691V16.875C1.5 17.7701 1.85558 18.6285 2.48851 19.2615C3.12145 19.8944 3.97989 20.25 4.875 20.25H19.125C20.0201 20.25 20.8785 19.8944 21.5115 19.2615C22.1444 18.6285 22.5 17.7701 22.5 16.875V8.691L22.1055 8.91075L12.3555 14.1608C12.2462 14.2196 12.1241 14.2504 12 14.2504C11.8759 14.2504 11.7538 14.2196 11.6445 14.1608L1.8855 8.9055L1.5 8.691Z" fill="#F9E109"/>
                            </svg>

                            <checkbox-field
                                v-model="account.isSubscribed"
                                isCheckmarkRight
                                :value="account.isSubscribed"
                                :label="$t('forms.joinForm.latestUpdatesSend')"
                                class="flex-grow-1"
                            />
                        </div> -->
                    </div>
                </div>

                <button
                    class="btn join-form__create-account-btn"
                    type="submit"
                    :disabled="invalid"
                    :class="{'btn-disabled': invalid}"
                >
                    {{ $t('buttons.registerNow') }}
                </button>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
    import jwtDecode from "jwt-decode";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import CustomSelect from '@/components/UIComponents/CustomSelect';
    import CheckboxField from '@/components/UIComponents/CheckboxField';
    import CustomInput from '@/components/Forms/CustomInput'
    import utils from '@/mixins/utils';
    import LinkBox from '@/components/SvgIcons/LinkBox'
    import ConfirmEmail from '@/components/SvgIcons/ConfirmEmail'
    import Attention from '@/components/SvgIcons/Attention'

    const ACCOUNT_ROLE_MEMBER = "restricted";
    const ACCOUNT_ROLE_AUTHOR = "author";
    const ACCOUNT_TYPE = "email";
    export default {
        name: "JoinForm",
        mixins: [utils],
        components: {
            CustomSelect,
            ValidationProvider,
            ValidationObserver,
            CheckboxField,
            CustomInput
        },
        data() {
            return {
                account: {
                    firstName: '',
                    lastName: '',
                    nick: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    isSubscribed: false,
                    type: 'email'
                },
                selectOptions: [
                    { text: this.capitalizeFirstLetter(this.$t('labels.'+ACCOUNT_ROLE_MEMBER)), value: ACCOUNT_ROLE_MEMBER },
                    { text: this.capitalizeFirstLetter(this.$t('labels.'+ACCOUNT_ROLE_AUTHOR)), value: ACCOUNT_ROLE_AUTHOR },
                ],
                defaultSelectValue: { text: this.capitalizeFirstLetter(this.$t('labels.'+ACCOUNT_ROLE_MEMBER)), value: ACCOUNT_ROLE_MEMBER },
                currentAccountRole: null,

                /**
                 * TODO fix register logic on account-service
                 * currentAccountRole
                 */
                //  currentAccountRole: null,
                 currentAccountRole: ACCOUNT_ROLE_MEMBER,
                // joinFormInputsAuthor: [
                //     {
                //         validationProviderRules: 'required|alpha',
                //         validationProviderName: 'forms.labels.firstName',
                //         label: 'forms.labels.firstName',
                //         type: 'text',
                //         model: 'firstName',
                //     },
                //     {
                //         validationProviderRules: 'required|alpha',
                //         validationProviderName: 'forms.labels.lastName',
                //         label: 'forms.labels.lastName',
                //         type: 'text',
                //         model: 'lastName',
                //     },
                // ],
                joinFormInputsCommon: [
                    {
                        validationProviderRules: 'required|max:20',
                        validationProviderName: 'forms.labels.username',
                        label: 'forms.labels.username',
                        type: 'text',
                        model: 'nick',
                    },
                    {
                        validationProviderRules: 'required|email',
                        validationProviderName: 'forms.labels.emailAddress',
                        label: 'forms.labels.emailAddress',
                        type: 'email',
                        model: 'email',
                        hint: 'forms.notes.emailMonitoringNote',
                    },
                    {
                        validationProviderRules: 'required|min:8|verify_password',
                        validationProviderName: 'forms.labels.password',
                        // validationProviderVid: 'password',
                        label: 'forms.labels.password',
                        type: 'password',
                        model: 'password',
                        showPasswordIcon: true,
                    },
                    {
                        validationProviderRules: 'required|confirm_password:@forms.labels.password',
                        validationProviderName: 'forms.labels.confirmPassword',
                        label: 'forms.labels.confirmPassword',
                        type: 'password',
                        model: 'confirmPassword',
                        showPasswordIcon: true
                    },
                ],
            }
        },
        async mounted () {
            if (this.$route.query.data) {

                await this.$store.dispatch('common/openPopup', {
                    icon: LinkBox,
                    text: 'Hi, we were not able to find a linked Ask4games Account. Would you like to link this Account?'
                })

                const { accessToken } = JSON.parse(this.$route.query.data)
                const { nick, avatarUrl, provider, type } = jwtDecode(accessToken)

                this.account.nick = nick
                this.account.avatarUrl = avatarUrl
                this.account.provider = provider
                this.account.type = type
            }
        },
        methods: {
            async resendConfirmationEmail(payload) {
                await this.$store.dispatch('common/closePopup');
                const res = await this.$api.auth.resendEmail(payload);

                if (res.data.success) {
                        await this.$store.dispatch('common/openPopup', {
                        icon: ConfirmEmail,
                        title: 'popup.emailConfirmation.title',
                        text: 'popup.emailConfirmation.text',
                    }, { root:true })
                    await this.$router.push({ path: this.localePath('/login')})
                }

                if (!res.data.success) {
                    await this.$store.dispatch('common/openPopup', {
                        icon: Attention,
                        title: 'popup.emailVerificationError.title',
                        text: 'popup.emailVerificationError.text',
                    }, { root:true })
                    await this.$router.push({ path: this.localePath('/login')})
                }
            },
            async handleJoin() {
                try {
                    const currentUserLocale = this.$i18n.locale;

                    const accountData = Object.assign({}, this.account)
                    accountData.type = ACCOUNT_TYPE
                    accountData.role = this.currentAccountRole
                    accountData.language = currentUserLocale
                    delete accountData.confirmPassword

                    if (this.currentAccountRole === ACCOUNT_ROLE_MEMBER) {
                        delete accountData.firstName
                        delete accountData.lastName
                    }

                    const res = await this.$store.dispatch('auth/signUp', { ...accountData })

                    if (res !== undefined) {
                        res.forEach(element => {
                            if (element.hasOwnProperty('email') && !element.valid) {
                                this.$store.dispatch('common/openPopup', {
                                    icon: ConfirmEmail,
                                    class: 'confirm-email-popup',
                                    isCloseBtnTopRight: true,
                                    title: this.$t('popup.emailVerification.title1'),
                                    text: this.$t('popup.emailVerification.text', {email: accountData.email}),
                                    additionalText: this.$t('popup.emailVerification.additionalText'),
                                    actionBtnText: this.$t('buttons.resendEmail'),
                                    actionBtnFun: () => {
                                        this.resendConfirmationEmail(accountData.email)
                                    }
                                }, { root:true })
                            }

                            if (element.hasOwnProperty('nick') && !element.valid) {
                                this.$store.dispatch('common/openPopup', {
                                    icon: ConfirmEmail,
                                    title: this.$t('popup.usernameAlreadyExist.title'),
                                    text: this.$t('popup.usernameAlreadyExist.text'),
                                }, { root:true })
                            }
                        });
                    }
                }catch (e) {
                    console.log(e)
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~assets/css/_vars.scss";
    @import "~assets/css/_extension.scss";

    .join-form {
        .custom-select {
            height: 44px;
            min-height: 44px;
            background-color: rgba(255, 255, 255, 0.1);
            border: none;
            &__label {
                font-weight: 600;
                font-size: $mainFontSize;
                line-height: 19px;
                top: -35px;
            }
            &__value {
                justify-content: space-between;
                padding-left: 25px;
            }
            &__options-list {
                padding-top: 10px;
            }
            &__option {
                text-align: left;
                &-title {
                    margin-left: 5px;
                }
            }
        }

        &__inputs-group {
            display: flex;
            flex-direction: column;
        }
        &__controls-group {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 70px;
            padding-right: 10px;
        }
        &__notification + .btn {
            width: 100%;
        }
        &__notification-icon {
            width: 24px;
            height: auto;
        }
        &__notification-paragraph {
            font-size: $smallTextFontSize;
            line-height: normal;
            margin-top: 0;
            margin-left: 10px;
            margin-bottom: 10px;
            text-align: left;
            color: rgba($mainLightFontColor, .5);
            a {
                color: rgba($mainLightFontColor, .5);
                text-decoration: underline;
                font-weight: 700;
                transition: $transitionAllFast;
                &:hover {
                    text-decoration: none;
                }
            }
        }
        &__paragraph {
            font-size: $bigTextFontSize;
            margin-top: 20px;
            margin-bottom: 20px;
            text-align: left;
        }
        &__account-info {
            font-weight: 600;
            font-size: $mainFontSize;
            line-height: 19px;
            color: $mainLightFontColor;
            margin-top: 30px;
            margin-bottom: 5px;
        }
        &__checkbox-container {
            display: flex;
            position: relative;
            align-items: center;
            // border: double 1px transparent;
            /* first gradient is for card background, second for border background */
            // background-image: linear-gradient($sectionIntermediateBg, $sectionIntermediateBg), linear-gradient(to right, $accentColor, $sectionIntermediateBg);
            // background-clip: padding-box, border-box;
            // background-origin: border-box;
            // padding: 10px 20px;
            padding-right: 20px;
            margin-bottom: 30px;
            font-size: $mainFontSize;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            .checkbox-label {
                font-weight: 400;
                margin-left: 10px !important;
            }
        }
        &__create-account-btn {
            min-height: 44px;
            width: 100%;
            margin-left: auto;
            background-color: $accentColor;
            border: 2px solid $accentColor;
            color: $mainLightColor;
            font-weight: bold;
            font-size: $mainFontSize;
            line-height: 19px;
            margin-bottom: 10px;
            &:hover {
                @extend %btnHoverBackgroundTransparent;
            }
            &:focus-visible {
                @extend %btnFocus;
            }
        }
    }
    .note {
        align-items: flex-start;
    }
    .aligned {
        border-top: 2px solid rgba($mainLightColor, 0.1);
        display: flex;
        flex-direction: column;
        margin-top: 40px;
    }

    @media (min-width: $breakpoint-extra-large-desktops) {
        .join-form {
            padding-left: 35px;
            padding-right: 35px;
        }
    }

    @media (max-width: $breakpoint-desktops) {
        .join-form {
            padding-left: 80px;
            padding-right: 80px;
            &__inputs-group {
                padding-left: 0;
                padding-right: 0;
            }
            &__controls-group {
                padding-left: 0;
                padding-right: 0;
            }
            &__notification {
                margin: 40px 0;
                &-paragraph {
                    max-width: 100%;
                }

            }
        }
    }

    @media (max-width: $breakpoint-tablet) {
        .join-form {
            padding: 0;
            .custom-select {
                max-width: 100%;
                height: 54px;
                &__option-title {
                    font-size: $bigTextFontSize;
                }
            }
            &__input {
                height: 54px;
            }
            &__create-account-btn {
                width: 100%;
                height: 54px;
                font-size: $bigTextFontSize;
                line-height: 22px;
            }
            &__notification {
                margin-top: 30px;
                margin-bottom: 60px;
            }
            &__checkbox-container {
                padding: 18px 20px 18px 0;
            }
            &__input-hint {
                font-size: $smallTextFontSize;
                line-height: 18px;
            }
            &__input {
                height: 54px;
                margin-bottom: 10px;
            }
        }
    }

    @media (max-width: $breakpoint-phone) {
        .join-form {
            margin-right: 0 !important;
            margin-left: 0 !important;
            padding-left: 3px;
            padding-right: 3px;
            &__inputs-group {
                padding: 0;
            }
            &__controls-group {
                padding-left: 0;
                padding-right: 0;
            }
            &__notification {
                margin-top: 30px;
            }
            &__notification-paragraph {
                margin-right: 20px;
            }
            &__create-account-btn {
                width: 100%;
            }
            .custom-select {
                &__option-title {
                    font-size: $bigTextFontSize;
                    margin-left: 15px;
                }
            }
        }
        .note {
            margin-bottom: 0;
        }
    }
</style>
